const Types = ( { cats, loading, error, selected, handleFilter } ) => {

	//console.log(selected);

    return (
		<div className={`types ${loading || error ? 'd-none' : ''}`}>
            <div className="row">
				<div className="col-md-12 text-start d-flex align-items-center">
					<span>FILTER&nbsp;BY:&nbsp;</span>
					<div className="d-flex">
						<ul className="nav nav-pills align-items-center p-2 ps-1">
							<li className="nav-item">
								<button
									className={`nav-link text-uppercase ${selected === 'all' ? 'active' : ''}`}
									id="all"
									value="all"
									onClick={() => handleFilter('all')}
								>
									All
								</button>
							</li>
							{cats.map((cat) => (
								<li key={cat.id}>
									<button
										className={`nav-link text-uppercase ${selected === cat.id ? 'active' : ''}`}
										id={cat.id}
										value={cat.slug}
										onClick={() => handleFilter(cat.id)}
									>
										{cat.name}
									</button>
								</li>
							))}
						</ul>
					</div>
				</div>
            </div>
        </div>
    );

}

export default Types;
